const BACKEND_HOST = "ml2sql.db.in.tum.de";
const BACKEND_PORT = 5000;
const EXECUTION_PORT = 5042;

export default { BACKEND_HOST, BACKEND_PORT, EXECUTION_PORT }
